import { Component, Input } from '@angular/core';
import { Approval } from 'ng2-app/models/dto/approval/approval.model';

@Component({
  selector: 'app-deal-details-smart',
  templateUrl: './deal-details-smart.component.html',
  styleUrls: ['./deal-details-smart.component.scss'],
  standalone: false
})

export class DealDetailsSmartComponent {
  @Input() deal: any;
  @Input() approvals: Approval[] = [];
  @Input() advancedDeal: boolean = false;

  constructor() { }
}
